import React from "react";

export const CasesMedium = () => {
  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 8H6.66667V4.66667H8M8 10.6667H6.66667V9.33333H8M0 12.6667H14.6667L7.33333 0L0 12.6667Z"
        fill="#FFEB32"
      />
    </svg>
  );
};

export default CasesMedium;
